import React, { useState } from 'react';
import ButtonOne from '../shared/ButtonOne';
import google from '../../assets/google-logo.svg';
import linkedin from '../../assets/linkedin.svg';
import { Link, useNavigate } from 'react-router-dom';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth } from '../../firebase';
import { useFormik } from 'formik';
import { axiosPublic } from '../../api/axios';
import { toast } from 'react-toastify';

const LoginForm = () => {
  const provider = new GoogleAuthProvider();
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false); // Track checkbox state
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      emailOrPhoneNumber: '', // ✅ match controller
      password: '',
    },
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const res = await axiosPublic.post('/auth/user/auth/login', {
          ...values,
          rememberMe, // ✅ send rememberMe as required by backend
        });

        const { token } = res.data;

        localStorage.setItem('token', token); // ✅ store JWT
        localStorage.setItem('user', JSON.stringify(values.emailOrPhoneNumber)); // Optional

        toast.success('Login successful!');
        navigate('/assessments'); // ✅ redirect on success
      } catch (err) {
        toast.error('Invalid credentials. Please try again!');
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <section className="md:pt-16 md:pb-24 sm:pt-12 sm:pb-16 pt-8 pb-12 bg-light-gray px-2">
      {loading && (
        <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center">
          <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4"></div>
          <h2 className="text-center text-white text-xl font-semibold">
            Logging you in...
          </h2>
          <p className="w-1/3 text-center text-white">
            This may take a few seconds, please don't close this page.
          </p>
        </div>
      )}
      <div className="mx-auto max-w-xl md:pt-5 sm:pt-4 pt-2 sm:pb-6 pb-4 md:pb-8 sm:px-6 px-4 md:px-8 bg-white rounded-3xl">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <h2 className=" text-center sm:text-2xl text-xl font-medium leading-9 tracking-tight text-gray-900">
            Welcome back!
          </h2>
        </div>
        <form className="space-y-6 sm:mt-4 mt-2" onSubmit={formik.handleSubmit}>
          <div>
            <label htmlFor="emailOrPhoneNumber" className="block sm:text-base text-sm font-medium leading-6 text-gray-900 mb-2">
              Email or Phone Number
            </label>
            <input
              id="emailOrPhoneNumber"
              name="emailOrPhoneNumber"
              type="text"
              autoComplete="email"
              required
              value={formik.values.emailOrPhoneNumber}
              onChange={formik.handleChange}
              className="sm:text-base text-sm block w-full p-1.5 h-14 text-gray-900 bg-white-gray ring-inset ring-gray-300 focus:ring-yellow-300 rounded-lg"
              placeholder="Enter your email or phone"
            />
          </div>
          <div>
            <label htmlFor="password" className="block sm:text-base text-sm font-medium leading-6 text-gray-900 mb-2">
              Password
            </label>
            <div className="relative">
              <input
                id="password"
                name="password"
                type="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                autoComplete="current-password"
                required
                className="sm:text-base text-sm block w-full p-1.5 h-14 text-gray-900 bg-white-gray ring-inset ring-gray-300 focus:ring-yellow-300 rounded-lg"
                placeholder="Enter your password"
              />
              <button type="button" className="absolute top-2/4 right-4 -translate-y-1/2">
                {/* eye icon */}
              </button>
            </div>
          </div>
          <div>
            <div className="flex items-center justify-between mb-6">
              <label className="flex items-center font-medium">
                <input
                  type="checkbox"
                  className="h-6 w-6 border-2 rounded mr-2"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)} // ✅ update state
                />
                Remember Me
              </label>
              <div className="text-sm">
                <a href="/" className="text-indigo-600 hover:text-indigo-500">
                  Forgot password?
                </a>
              </div>
            </div>
          </div>
          <div>
            <button
              type="submit"
              className="w-full rounded-md bg-amber-300 p-1.5 font-medium sm:text-base text-sm leading-6 shadow-sm focus:outline-none focus:ring-2 focus:ring-yellow-300 sm:py-4 py-2"
            >
              Sign in
            </button>
          </div>
        </form>
      </div>
      <p className="mt-10 text-center sm:text-base text-sm text-gray-500">
        Don't have an account?
        <Link
          to="/sign-up"
          className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500 underline"
        >
          Create Account
        </Link>
      </p>
    </section>
  );
};

export default LoginForm;
